import request from '@/plugins/axios'

/** S 商城列表 **/
// 商城列表
export const apiShopLists = (params: any) => request.get('/shop.shop/lists', {params})

//不带分页的商城列表
export const apiNewsShopLists = (params: any) => request.get('/shop.shop/getShopList', {params})

// 添加商城
export const apiShopAdd = (params: any) => request.post('/shop.shop/add', params)

// 商城详情
export const apiShopDetail = (params: any) => request.get('/shop.shop/detail', {params})

// 编辑商城
export const apiShopEdit = (params: any) => request.post('/shop.shop/edit', params)

// 复制商城数据
export const apiShopCp = (params: any) => request.post('/shop.shop/shopCp', params)

// 删除商城
export const apiShopDelete = (params: any) => request.post('/shop.shop/delete', params)

// 修改超级管理员
export const apiShopChangeSuperAdmin = (params: any) => request.post('/shop.shop/changeSuperAdmin', params)

// 修改商城状态
export const apiShopSwitchStatus = (params: any) => request.post('/shop.shop/switchStatus', params)

// 历史套餐
export const apisetMealLogLists = (params: any) => request.get('/shop.shop/setMealLogLists', {params})

// 修改商城备注
export const apiChangeRemark = (params: any) => request.post('/shop.shop/changeRemark', params)
/** E 商城列表 **/

/** S 套餐列表 **/
// 套餐列表
export const apiSetMealLists = (params: any) => request.get('/shop.set_meal/lists', {params})

/** S 店铺审核 **/
// 店铺审核列表
export const apiShopCheckLists = (params: any) => request.get('/shop.Index/lists', {params})
// 店铺审核详情
export const apiShopCheckDetail = (params: any) => request.get('/shop.Index/detail', {params})
// 添加店铺审核
export const apiShopCheckAdd = (params: any) => request.post('/shop.Index/add', params)
// 编辑店铺审核
export const apiShopCheckEdit = (params: any) => request.post('/shop.Index/edit', params)

// 添加套餐
export const apiSetMealAdd = (params: any) => request.post('/shop.set_meal/add', params)

// 套餐详情
export const apiSetMealDetail = (params: any) => request.get('/shop.set_meal/detail', {params})

// 编辑套餐
export const apiSetMealEdit = (params: any) => request.post('/shop.set_meal/edit', params)

// 删除套餐
export const apiSetMealDelete = (params: any) => request.post('/shop.set_meal/del', params)

// 修改套餐状态
export const apiSetMealSwitchStatus = (params: any) => request.post('/shop.set_meal/status', params)

export const apiMealModule = () => request.get('/shop.set_meal/getMealModule')

//获取是否配置项
export const apiGetExConfig = () => {
    return request({
        url: '/shop.shop/getExConfig',
        method: 'get'
    })
}
/** E 套餐列表 **/

/** S 推广模块 **/
// 推广模块列表
export const apiPromotionModuleLists = (params: any) => request.get('/shop.promotion_module/lists', {params})

// 添加推广模块
export const apiPromotionModuleAdd = (params: any) => request.post('/shop.promotion_module/add', params)

// 推广模块详情
export const apiPromotionModuleDetail = (params: any) => request.get('/shop.promotion_module/detail', {params})

// 编辑推广模块
export const apiPromotionModuleEdit = (params: any) => request.post('/shop.promotion_module/edit', params)

// 删除推广模块
export const apiPromotionModuleDel = (params: any) => request.post('/shop.promotion_module/delete', params)


export const apiPromotionModuleLists1 = (params: any) => request.get('/shop.promotion_module1/lists', {params})

// 添加推广模块
export const apiPromotionModuleAdd1 = (params: any) => request.post('/shop.promotion_module1/add', params)

// 推广模块详情
export const apiPromotionModuleDetail1 = (params: any) => request.get('/shop.promotion_module1/detail', {params})

// 编辑推广模块
export const apiPromotionModuleEdit1 = (params: any) => request.post('/shop.promotion_module1/edit', params)

// 删除推广模块
export const apiPromotionModuleDel1 = (params: any) => request.post('/shop.promotion_module1/delete', params)

//导入推广模块
export const apiImportPromotionModule = (params: any) => request.post('/shop.promotion_module1/import', params)


//导入推广模块
export const apiImportPromotionModule1 = (params: any) => request.post('/shop.promotion_module/import', params)

/** E 推广模块 **/

/** S 视频模块 **/
// 视频列表
export const apiVideoLists = (params: any) => request.get('/shop.video/lists', {params})

// 添加视频
export const apiVideoAdd = (params: any) => request.post('/shop.video/add', params)

// 视频详情
export const apiVideoDetail = (params: any) => request.get('/shop.video/detail', {params})

// 编辑视频
export const apiVideoEdit = (params: any) => request.post('/shop.video/edit', params)

// 删除视频
export const apiVideoDel = (params: any) => request.post('/shop.video/delete', params)

/** E 视频模块 **/

/** S 资讯模块 **/
// 资讯列表
export const apiNewsLists = (params: any) => request.get('/shop.news/lists', {params})

// 添加资讯
export const apiNewsAdd = (params: any) => request.post('/shop.news/add', params)

// 资讯详情
export const apiNewsDetail = (params: any) => request.get('/shop.news/detail', {params})

// 编辑资讯
export const apiNewsEdit = (params: any) => request.post('/shop.news/edit', params)

// 删除资讯
export const apiNewsDel = (params: any) => request.post('/shop.news/delete', params)
/** E 资讯模块 **/

/** S 资讯管理 **/
// 资讯列表
export const apiArticleLists = (params: any) => request.get('/shop.article/lists', {params})

// 添加资讯
export const apiArticleAdd = (params: any) => request.post('/shop.article/add', params)

// 资讯详情
export const apiArticleDetail = (params: any) => request.get('/shop.article/detail', {params})

// 编辑资讯
export const apiArticleEdit = (params: any) => request.post('/shop.article/edit', params)

// 删除资讯
export const apiArticleDel = (params: any) => request.post('/shop.article/delete', params)

// 修改资讯显示状态
export const apiArticleIsShow = (params: any) => request.post('/shop.article/isShow', params)
/** E 资讯管理 **/

/** S 资讯分类 **/
// 资讯分类列表
export const apiArticleCategoryLists = (params: any) => request.get('/shop.article_category/lists', {params})

// 添加资讯分类
export const apiArticleCategoryAdd = (params: any) => request.post('/shop.article_category/add', params)

// 资讯分类详情
export const apiArticleCategoryDetail = (params: any) => request.get('/shop.article_category/detail', {params})

// 编辑资讯分类
export const apiArticleCategoryEdit = (params: any) => request.post('/shop.article_category/edit', params)

// 删除资讯分类
export const apiArticleCategoryDel = (params: any) => request.post('/shop.article_category/delete', params)

// 修改资讯分类显示状态
export const apiArticleCategoryIsShow = (params: any) => request.post('/shop.article_category/isShow', params)

/** E 资讯分类 **/

/** S 视频列表 **/
// 视频列表
export const apiVideo2Lists = (params: any) => request.get('/shop.AiVideo/lists', {params})

//不带分页的视频列表
export const apiNewsVideoLists = (params: any) => request.get('/shop.AiVideo/getVideoList', {params})

// 添加视频
export const apiVideo2Add = (params: any) => request.post('/shop.AiVideo/add', params)

// 视频详情
export const apiVideo2Detail = (params: any) => request.get('/shop.AiVideo/detail', {params})

// 编辑视频
export const apiVideo2Edit = (params: any) => request.post('/shop.AiVideo/edit', params)

// 复制视频数据
export const apiVideo2Cp = (params: any) => request.post('/shop.AiVideo/shopCp', params)

// 删除视频
export const apiVideo2Delete = (params: any) => request.post('/shop.AiVideo/delete', params)